import React, { Component } from 'react'
import Link from 'gatsby-link'
import Modal from 'react-modal'

class NavPanel extends Component {
  wrapLink = (text, href) => (
    <Link
      className="link depth-0"
      to={href}
      onClick={this.props.onToggleNavPanel}
    >
      <span className="indent-0">{text}</span>
    </Link>
  )
  render() {
    const { onToggleNavPanel, isOpen } = this.props
    return (
      <div>
        <div className="navButton">
          <a onClick={onToggleNavPanel} className="toggle" />
        </div>
        <div className="navPanel">
          <nav>
            {this.wrapLink('HOME', '/')}
            {this.wrapLink('NEWS', '/news')}
            {this.wrapLink('TEAM', '/team')}
            {this.wrapLink('BUY', '/buy')}
          </nav>
        </div>
      </div>
    )
  }
}

export default NavPanel



// WEBPACK FOOTER //
// ./src/components/navpanel.js